export const REACT_APP_NAME: string = import.meta.env.VITE_REACT_APP_NAME;
export const REACT_APP_AUTH_URI: string = import.meta.env.VITE_REACT_APP_AUTH_URI;
export const REACT_APP_DB_NAME: string = import.meta.env.VITE_REACT_APP_DB_NAME;
export const REACT_APP_API_URI: string = import.meta.env.VITE_REACT_APP_API_URI;
export const REACT_APP_NODEJOBAPI_URI: string = import.meta.env.VITE_REACT_APP_NODEJOBAPI_URI;
export const REACT_APP_PYJOBAPI_URI: string = import.meta.env.VITE_REACT_APP_PYJOBAPI_URI;
export const REACT_APP_GIT_HASH: string = import.meta.env.VITE_REACT_APP_GIT_HASH || "dev";
export const VITE_DATE: string = import.meta.env.VITE_DATE || "not released";
